import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";
import { modPointsReportV2_template } from "../components/templates/modPointsReportV2_template";

declare var ko: any;
declare var page: any;

export class mod_points_report_v2 extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: modPointsReportV2_template;
    protected timer;

    protected getModuleName(){

        return "mod_points_report_v2";
    }

    buildContent() : Array<Element>{

        this.elementsList = new modPointsReportV2_template("list", this.viewModel, this);
        this.template = this.elementsList;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Mod Points Report (v2)");

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        this.updateViewModelFromPath();
        this.getfilterReference();
    }

    protected listReorder(){

        this.filterList();
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange(){

        this.filterList();
    }

    protected getMemoryViewModel(){

        let templateViewModel = this.elementsList.getTemplateViewModel();

        delete templateViewModel.mods;

        return templateViewModel;
    }

    protected view(id){

        window.open('/website-users/edit/' + id, '_blank');
    }

    protected viewPointDetails(id){
        window.open('/mods/points/v2/report/byuser/' + id + '/');
    }

    protected viewOnSite(data){

        let origin = document.location.origin;
        let brandDomain = 'ggmods.com';

        let url = origin.replace("emakicms.com",brandDomain) + '/mods/'+ this.slugify(data.tag.name) + '/' + (data.idOrigin ? data.idOrigin : data.id);
        window.open(url, '_blank');
    }

    public getfilterReference(): void{

        if( "getfilterReference" in this.XHRHdls ){
            this.XHRHdls["getfilterReference"].cancelAndReset();
        }

        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/mod/references';
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdls['getfilterReference'] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdls['getfilterReference'].onReadyStateFunction = this.onFilterReferenceRequestReturn;
        this.XHRHdls['getfilterReference'].execute();
    }

    protected onFilterReferenceRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                JSON.parse(req.request.response);
                obj.filterList();
            });

        }
    }

    protected filterList(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        this.timer = new Date().getTime();
        let usrReq_url: string = '/api/mod/points/v2/getTotals/';
        let subViewModel = this.elementsList.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'mods');
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
                obj.updateViewModelFromPath();
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            });

        }
    }

    protected updateList(responseParsed: any){

        this.elementsList.setMods(responseParsed.paginatedResults.data);

        let execTime = Math.round((new Date().getTime() - this.timer)/1000*100)/100;
        this.elementsList.setResultInfo(responseParsed.paginatedResults.totalCount, responseParsed.paginatedResults.totalPage,execTime );

        this.viewModel.list.pagination.itemCount(responseParsed.paginatedResults.totalCount);
    }


    public add() {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.saveViewModule(this.getMemoryViewModel());
        page('/mods/add/')
    }

    protected getTagsSuggestion(keyword, idElement) {

        if( "getTagSuggestion" in this.XHRHdls ){
            this.XHRHdls["getTagSuggestion"].cancelAndReset();
        }

        let tagTypesIds = [222, 1191]
        let usrReq_url: string = '/api/tags/get_by_types/';
        let subViewModel = {keyword: keyword, tagTypesIds: tagTypesIds, idElement: idElement }
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getTagSuggestion'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getTagSuggestion'].onReadyStateFunction = this.onGetTagByTypeSuggestionReturn;
        this.XHRHdls['getTagSuggestion'].execute();
    }

    protected onGetTagByTypeSuggestionReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    if (responseParsed.data) {
                        obj.elementsList.tagFilter.setTags(responseParsed.data);
                    }
                }
            }
        }
    }

    protected getUsersSuggestion(keyword, idElement) {

        if( "getUsersSuggestion" in this.XHRHdls ){
            this.XHRHdls["getUsersSuggestion"].cancelAndReset();
        }

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if(!idBrand){
            idBrand = "53"
        }

        let subViewModel = {list: {keyword: keyword, limit: 100}, idElement: idElement, idBrand: idBrand};
        let usrReq_url: string = '/api/search/website-users/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getUsersSuggestion'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getUsersSuggestion'].onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdls['getUsersSuggestion'].execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {


                let responseParsed = JSON.parse(req.request.response || '{}');

                if (req.request.status == 200) {

                    if (responseParsed.data.users) {
                        obj.elementsList.userFilter.setUsers(responseParsed.data.users);
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                }

                obj.elementsList.deactivateLoading();
            }
        }
    }

    private slugify(text) {

        text = typeof text === 'string' ? text : '';
        text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        text = text.replace(/[^a-zA-Z0-9\s_-]/g, '');
        text = text.replace(/[\s-]+/g, '-');
        text = text.replace(/^-+|-+$/g, '');
        return text.toLowerCase();
    }

}



// WEBPACK FOOTER //
// ./js/modules/mod_points_report_v2.ts